module.exports = __webpack_public_path__ + "img/744.95620a4a.jpg";